import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'epc-dashboard-empty-state',
  templateUrl: './dashboard-empty-state.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DashboardEmptyStateComponent {
  @Input() public hasFiltersSelected = false;

  @Output() public clearFilters = new EventEmitter<void>();
}
